export enum ReferralType {
  default = 'default', // likely not used anymore
  healix = 'healix',
  landg = 'landg', // L&G Referral (child of L&G org)
  landgci = 'landgci', // L&G CI (child of L&G org)
  aviva = 'aviva',
  generic = 'generic', // should supersede custom organizations
  cluk = 'cluk',
  vitality = 'vitality',
}
